<template>
    <div class="modal fade" tabindex="-1" role="dialog" ref="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"><i class="fas fa-globe"></i> Máte neuložené změny</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            @click="visible = false">
                    </button>
                </div>
                <div class="modal-body">
                    <p>Zatímco jste byli offline, upravovali jste popis nemovitosti.</p>
                    <p>Chcete tyto změny uložené ve vašem zařízení nahrát uložit do INEMu?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="sync">Uložit do INEMu</button>
                    <button type="button" class="btn btn-secondary" @click="clear">Zahodit změny</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {EstimateState} from '@/model/api';
import {OfflineManager} from '@/model/offline/OfflineManager';
import {Modal} from 'bootstrap';
import {defineComponent, onMounted, PropType, ref} from 'vue';

export default defineComponent({
    props: {
        offlineManager: {
            type: Object as PropType<OfflineManager>,
            required: true,
        },
        lastKnownEstimateState: {
            type: Object as PropType<EstimateState>,
            required: true,
        },
    },
    emits: ['sync'],
    setup(props, {emit, expose}) {
        const modal = ref<HTMLElement | null>(null);
        let modalInstance: Modal;

        function show(): void {
            modalInstance.show();
        }

        function sync(): void {
            props.offlineManager.syncWithServer(props.lastKnownEstimateState)
                .then((estimate) => {
                    emit('sync', estimate);
                    modalInstance.hide();
                })
                .catch(() => {
                    props.offlineManager.clear();
                    modalInstance.hide();
                });
        }

        function clear(): void {
            props.offlineManager.clear();
            modalInstance.hide();
        }

        onMounted(() => {
            modalInstance = new Modal(modal.value as HTMLElement);
        });

        expose({show});

        return {modal, show, sync, clear};
    },
});
</script>
